'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const utils_clamp = require('../../../utils/clamp.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_8t3l7_1";
const progress = "_progress_8t3l7_9";
const styles = {
	root: root,
	progress: progress
};

const ProgressBar = (_a) => {
  var { max = 1, min = 0, color = "UiPrimaryStrongest" } = _a, props = tslib_es6.__rest(_a, ["max", "min", "color"]);
  const value = utils_clamp.clamp(props.value, min, max);
  const range = max - min;
  const decimal = (value - min) / range;
  const width = `${decimal * 100}%`;
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    React__default.default.createElement("div", { className: styles.progress, "data-testid": "progress", "data-zds": true, style: {
      "--progress-bar-width": width,
      "--progress-bar-color": theme_Colors.Colors[color]
    } })
  );
};

exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.cjs.js.map
